exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".v6_NaCTzdLH8aN2TYSGeY{position:absolute;width:0;height:0;opacity:0}", ""]);
// Exports
exports.locals = {
	"button": "v6_NaCTzdLH8aN2TYSGeY"
};